export default class Authorization {
  static get ROLES() {
    return {
      admin: 'GS-WBF-eform.Admin',
      user: 'GS-WBF-eform.ALLOW'
    }
  }
}
